<form class="form-container flex flex-column" (validate)="login()" novalidate>
  <label for="username">{{screen.username}}</label>
  <input pInputText type="text" name="username" [(ngModel)]="data.username" [required]="true"
    [requiredMessage]="screen.usernameRequiredMsg" autocomplete="off" validation />

  <label for="password">{{screen.password}}</label>
  <input pInputText type="password" name="password" [(ngModel)]="data.password" [required]="true"
    [requiredMessage]="screen.passwordRequiredMsg" autocomplete="off" validation />

  <div class="align-self-center">
    <button pButton [label]="screen.continue" class="p-button-success" type="submit" *ngIf="!loading"></button>
    <button pButton [label]="screen.continue" class="p-button-success" type="button" [icon]="loadingIcon"
      *ngIf="loading"></button>
  </div>
</form>